// Recovers from a real race: flickity-carousel/index.js constructs every
// carousel with watchCSS: true, which reads the CSS content value of
// .flickity-carousel::after to decide whether to activate(). That CSS lives
// in the pattern-content stylesheet, which the framework's performance layer
// (Performance::defer_content_css()) loads asynchronously (media="print",
// swapped to "all" via the link's own onload). If Flickity constructs before
// that swap happens, watchCSS() reads the wrong value and silently calls
// deactivate() instead — the carousel never gets cells/slides/viewport or the
// flickity-enabled/is-draggable classes, with no error anywhere. The only
// thing that makes Flickity re-check is a window 'resize' event.
//
// window.load only fires once every resource — including that deferred
// stylesheet — has finished downloading, regardless of its current media
// value, so the stylesheet's onload swap has always already run by then.
// Dispatching resize at that point makes Flickity re-run its own watchCSS()
// correctly, using its own supported recovery path rather than a guess.
//
// Also covers a separate, already-known framework bug (Scripts.php's
// combine_pattern_js() can drop the lib-flickity script dependency when
// combining pattern scripts) via the opacity-fallback timeout below, since
// that failure mode has no live instance for a resize dispatch to recover.
export default function () {

  const carousels = document.querySelectorAll('.flickity-carousel');
  if (!carousels.length) return;

  const recheck = function () {
    window.dispatchEvent(new Event('resize'));
  };

  if (document.readyState === 'complete') {
    recheck();
  } else {
    window.addEventListener('load', recheck, { once: true });
  }

  setTimeout(function () {
    recheck();
    carousels.forEach(function (carousel) {
      if (!carousel.classList.contains('flickity-enabled')) {
        carousel.classList.add('flickity-fallback-visible');
      }
    });
  }, 4000);

}
